<template>
  <div>
    <div class="salary-item row" v-for="salary in salaries" v-bind:key="salary.id">
      <Salary class="col" v-bind:salary="salary"></Salary>

      <div class="actions">
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-dark" v-on:click="editSalary(salary)">
            <font-awesome-icon icon="pencil-alt"/>
          </button>
          <button type="button" class="btn btn-dark" v-on:click="delSalary(salary)">
            <font-awesome-icon icon="trash-alt"/>
          </button>
        </div>
      </div>
    </div>

    <ModalQuestion ref="question"></ModalQuestion>
    <SalaryEdit ref="salary"></SalaryEdit>
  </div>
</template>

<script>
export default {
  props: ["salaries"],
  methods: {
    refresh() {
      this.$emit('refresh', this.salaries);
    },
    addSalary(newSalary) {
      let salary = newSalary || this.$piggyBank.data.newSalary();

      this.$refs.salary
        .show(salary)
        .then(result => {
          this.salaries.push(result);
        })
        .catch(() => {})
        .finally(this.refresh);
    },
    editSalary(salary) {
      this.$refs.salary
        .show(salary)
        .then(result => {
          let index = this.salaries.indexOf(salary);
          this.salaries[index] = result;
        })
        .catch(() => {})
        .finally(this.refresh);
    },
    delSalary(salary) {
      this.$refs.question
        .ask("Czy usunąć wypłate")
        .then(() => {
          let index = this.salaries.indexOf(salary);
          this.salaries.splice(index, 1);
        })
        .catch(() => {})
        .finally(this.refresh);
    }
  }
};
</script>

<style lang="scss" scoped>
.salary-item {
  .mobile & {
    .actions {
      display: none;
    }
  }
}
</style>